import { render, staticRenderFns } from "./BiometricTerms.vue?vue&type=template&id=199999fb"
import script from "./BiometricTerms.vue?vue&type=script&lang=js"
export * from "./BiometricTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports